import { jsx as _jsx } from "react/jsx-runtime";
import RegistryFields from './registry-fields';
function PropertiesComponentFields({ settingIndex }) {
    // PropertiesComponentFields are the same as RegistryFields
    return _jsx(RegistryFields, { settingIndex: settingIndex });
}
export default PropertiesComponentFields;
